import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import AirPortTicketInfo from '../../../components/AirPortTicketInfo.vue';
import BlockRadioGroup from '../../../components/BlockRadioGroup.vue';
import config from '../../../api/params.config';


@Component({
    components: {
      AirPortTicketInfo,
      BlockRadioGroup,
    },
    // 过滤器 格式化金额
    filters: {
      Money(data: number) {
        return typeof(data) === 'number' ? '+' + data.toFixed(2) : data;
      },
      DisCount(data: number) {
        return (data * 10).toFixed(1) + '折';
      },
      ServiceLevel(data: string) {
        const ServiceLevel: any = {
          F: '头等舱',
          C: '商务舱',
          Y: '经济舱',
        };
        return ServiceLevel[data];
      },
    },
})
export default class AirTicketChoose extends Vue {
  private $api: any;
  private userRoleType: number = 0;       // 用户类型 0(普通员工) 1(部门经理) 2(订票专员)
  private AirTicketFor: any;              // 订票 改签 重订 ? 'booking' 'change' 'rebooking' 
  private CurrentAirport: any = JSON.parse(localStorage.getItem('CurrentAirport') || ''); // 当前选择的航班
  private CurrentAirTicket: any;          // 当前选择的机票 (用于选择预定原因时记录所选机票)
  private refundRules: any = {};          // 退改签政策
  private showPopup: boolean = false;     // 是否展示退改签政策弹出层
  private AirTicketTrip: any = '';        // 订票使用的行程
  private ReasonObj: any = '';           // 选择到的原因对象
  private Reason: string = '';      // 选择的预定原因文本
  private ReasonType = '';          // 当前的预定原因类型Id (来自全局变量config)
  private ReasonDialogType = '';    // 显示哪种类型的原因，时间相关或者价格相关, 赋值 'date' || 'price'
  private ReasonDialogExamineType = 0;    // 弹出框中审核人的类型, 总经理(1)或者订票专员(2)
  private ReasonDialogShow = false; // 弹出选择原因弹出框
  private IsBookingTicketRole: boolean = false;     // 是否是订票专员
  private IsGeneralManagerRole: boolean = false;     // 是否是总经理
  private IsBUManageerRole: boolean = false;     // 是否是事业部负责人

  
  private async QueryRefundPolicy() {
    const params = {
      airRoute: this.CurrentAirport.No,     // 航线"SZXPEK"
      airlineCode: this.CurrentAirport.Airline,  // 航司"ZH"
      depTime: this.CurrentAirport.DepartTime,      // 起飞时间 11:20
      departDate: moment(this.CurrentAirport.DepartDate).format('YYYY-MM-DD'),   // 起飞日期 2019-04-21
      parPrice: this.CurrentAirport.Detail[0].ParPrice,     // 票面价 1500 当前仓位
      cabin: this.CurrentAirport.Detail[0].Cabin,         // 仓位"Y"
    };
    const result = await this.$api.httpPost('basic/Ticket/TicketRefundPolicyForOrder', params);
    if (result.Success) {
      this.refundRules = result.Data;
    }
  }

  // 当点击退改详情触发
  private onShowPopup() {
    this.showPopup = true;
  }

  // 关闭弹出框
  private cancelPopup() {
    this.showPopup = false;
  }

  // 退改签详情分行
  private getLine(str: string) {
    if (!str) {
      return '未查到相关退改签政策信息';
    }

    str = str.replace(/&#40;/g, '(');
    str = str.replace(/&#41;/g, ')');

    let newStr = '';
    let rows: any = str.split(';');
    // console.log(rows);
    
    for (const i of rows) {
      newStr += `<br/>${i}`;
    }
    // console.log(newStr);
    return newStr;
  }

  // 检查预定是否需要审核原因
  private checkReason(airticket: any) {
    this.CurrentAirTicket = airticket;
    let ReasonType = config.BookingAduitReason_NoNeedAudit;

    // 如果不是订票专员、总经理、事业部负责人，则需要验证是否需要审批
    if (!this.IsBookingTicketRole && !this.IsGeneralManagerRole && !this.IsBUManageerRole) {
      if (moment(this.CurrentAirport.DepartDate).subtract(2, 'days').isSameOrBefore(moment(), 'day')) {
        // 原因 时间与出发日期小于3天
        ReasonType = config.BookingAduitReason_Less3Days;
        this.ReasonDialogType = 'date';
        this.ReasonDialogExamineType = 1;
      } else if (this.CurrentAirTicket.Discount >= 0.6) {
        // 原因 6折以上
        ReasonType = config.BookingAduitReason_DiscountLGreater6;
        this.ReasonDialogType = 'price';
        this.ReasonDialogExamineType = 2;
      } else {
        // 不需要审核，直接去订票
        this.ReasonType = ReasonType;
        this.checkReBookingAirTicket(this.CurrentAirTicket);
        return;
      }
      // 需要审核，弹出选择框
      this.ReasonType = ReasonType;
      this.ReasonDialogShow = true;
    } else {
      this.ReasonType = ReasonType;
      this.checkReBookingAirTicket(this.CurrentAirTicket);
    }


    // if (this.userRoleType !== 2) {
    //   // 如果不是订票专员,检查条件
    //   if (moment(this.CurrentAirport.DepartDate).subtract(3, 'days').isSameOrBefore(moment(), 'day')) {
    //     // 原因 时间与出发日期小于3天
    //     ReasonType = config.BookingAduitReason_Less3Days;
    //     this.ReasonDialogType = 'date';
    //     this.ReasonDialogExamineType = 1;
    //   } else if (this.CurrentAirTicket.Discount >= 0.9) {
    //     // 原因 9折以上的机票
    //     ReasonType = config.BookingAduitReason_DiscountGreater9;
    //     this.ReasonDialogType = 'price';
    //     this.ReasonDialogExamineType = 1;
    //   } else if (this.CurrentAirTicket.Discount < 0.9 && this.CurrentAirTicket.Discount >= 0.6) {
    //     // 原因 9折以下6折以上
    //     ReasonType = config.BookingAduitReason_DiscountBetween6And9;
    //     this.ReasonDialogType = 'price';
    //     this.ReasonDialogExamineType = 2;
    //   } else if (this.CurrentAirTicket.Discount < 0.6 && (this.CurrentAirTicket.SalePrice - this.CurrentAirport.MinSalePrice >= 300)) {
    //     // 原因 6折以下但价格与当日最低票价差额超过300
    //     ReasonType = config.BookingAduitReason_DiscountLess6ButDifferenceGreater300;
    //     this.ReasonDialogType = 'price';
    //     this.ReasonDialogExamineType = 2;
    //   } else {
    //     // 不需要审核，直接去订票
    //     this.ReasonType = ReasonType;
    //     this.checkReBookingAirTicket(this.CurrentAirTicket);
    //     return;
    //   }
    //   // 需要审核，弹出选择框
    //   this.ReasonType = ReasonType;
    //   this.ReasonDialogShow = true;
    // } else {
    //   this.ReasonType = ReasonType;
    //   this.checkReBookingAirTicket(this.CurrentAirTicket);
    // }
    
  }

  // 点击确定，关闭前的回调函数
  private beforeSubmit(action: any, done: any) {
    if (!this.Reason && action === 'confirm') {
      this.$toast('请填写原因');
      done(false);
    } else {
      if (this.Reason && action === 'confirm') {
        this.checkReBookingAirTicket(this.CurrentAirTicket);
      }
      done();
    }
  }

  // 检查重新订票
  private async checkReBookingAirTicket(airticket: any) {
    if (this.AirTicketFor === 'rebooking') {
      this.$toast.loading({
        duration: 0,       // 持续展示toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '正在检查机票状态...',
      });

      const trip = JSON.parse(this.AirTicketTrip);
      console.log(trip);
      const result = await this.$api.httpGet('basic/Ticket/GetReturnTicketStateById', { Id: trip.Id });
      this.$toast.clear();
      if (result.Success) {
        // 如果是订票中或者订票成功
        if (result.Data === 2 || result.Data === 6) {
          this.$toast('机票状态已更新');
          this.$router.push('/tripinfo-list');
        } else {
          this.toSubmit(airticket);
        }
      } else {
        this.$notify(result.AllMessages);
      } 
    } else {
      this.toSubmit(airticket);
    }
  }

  // 预订，去订票页
  private toSubmit(airticket: any) {
    const AirTicketReason = {
      id: this.ReasonType,
      text: this.Reason,
    };
    console.log(AirTicketReason);
    localStorage.setItem('AirTicketFor', this.AirTicketFor);
    localStorage.setItem('AirTicketReason', JSON.stringify(AirTicketReason));
    localStorage.setItem('AirTicketTrip', this.AirTicketTrip);
    localStorage.setItem('CurrentAirport', JSON.stringify(this.CurrentAirport));
    localStorage.setItem('CurrentAirTicket', JSON.stringify(airticket));
    this.$router.push('/airticket-submit');
  }

  // 获取用户角色，是否为订票专员、总经理、部门负责人
  private async getUserIsCommissioner() {
    const result = await this.$api.httpGet('Membership/TripBookTicket/TicketBookingJudgePermission');
    if (result.Success) {
      this.IsBookingTicketRole = result.Data.IsBookingTicketRole;
      this.IsGeneralManagerRole = result.Data.IsGeneralManagerRole;
      this.IsBUManageerRole = result.Data.IsBUManageerRole;
    }
  }

    // 返回审批
    private goBack() {
      this.$router.go(-2);
    }

  private created() {
    this.AirTicketFor = localStorage.getItem('AirTicketFor') || '';
    this.AirTicketTrip = localStorage.getItem('AirTicketTrip') || '';
    this.getUserIsCommissioner();

    console.log(this.CurrentAirport);
  }

  // life cycle
  private mounted() {
    this.QueryRefundPolicy();
  }

}
